import { Table } from "common/Table/Table";
import { useRouter } from "hooks/useRouter";
import { Fragment, useCallback, useEffect, useState } from "react";
import UserService from "services/user.service";
import { formatDate } from "utils/funcs";
import { DEFAULT_SEASON_YEAR_NUMBER } from "utils/seasonYear";

const service = new UserService();

export const SolarLeadManagement = () => {
  // "solar_closure": [
  //     {
  //         "closure_name": "Gabriel Gaertner",
  //         "calendar_id": 10315848,
  //         "timezone": "America/Phoenix",
  //         "is_book": false,
  //         "time_stamp": 1721806316917,
  //         "badge_id": "231816"
  //     },
  //     {
  //         "closure_name": "Levi Childers",
  //         "calendar_id": 10316352,
  //         "timezone": "America/Phoenix",
  //         "is_book": false,
  //         "time_stamp": 1721806316917,
  //         "badge_id": "128022"
  //     }
  // ],
  const { push } = useRouter();

  const columns = [
    {
      key: "id",
      dbColName: "id",
      title: "id",
      label: "id",
    },
    {
      key: "name",
      dbColName: "name",
      title: "name",
      label: "name",
      render: (value) => <p>{value.split("-")[1]}</p>,
      freeze: true,
      freezeIndex: "left-0",
    },
    {
      key: "office_name",
      dbColName: "office_name",
      title: "office name",
      label: "office_name",
    },
    { key: "email", dbColName: "email", title: "email", label: "email" },
    {
      key: "replyTo",
      dbColName: "replyTo",
      title: "reply to",
      label: "replyTo",
    },
    {
      key: "description",
      dbColName: "description",
      title: "description",
      label: "description",
    },
    {
      key: "location",
      dbColName: "location",
      title: "location",
      label: "location",
    },
    {
      key: "timezone",
      dbColName: "timezone",
      title: "timezone",
      label: "timezone",
    },
    {
      key: "thumbnail",
      dbColName: "thumbnail",
      title: "thumbnail",
      label: "thumbnail",
    },
    { key: "image", dbColName: "image", title: "image", label: "image" },

    {
      key: "order_type",
      dbColName: "order_type",
      title: "order type",
      label: "order_type",
    },
    {
      key: "order_frequency",
      dbColName: "order_frequency",
      title: "order frequency",
      label: "order_frequency",
    },
    {
      key: "orderKpi",
      dbColName: "orderKpi",
      title: "Order kpi",
      label: "orderKpi",
    },
    {
      key: "kpiDuration",
      dbColName: "kpiDuration",
      title: "kpi duration",
      label: "kpiDuration",
    },
    {
      key: "kpi_duration_date",
      dbColName: "kpi_duration_date",
      title: "kpi duration date",
      render: date => formatDate(date),
      label: "kpi_duration_date",
    },
    {
      key: "action",
      dbColName: "_id",
      title: "action",

      freeze: true,
      freezeIndex: "right-0",
      render: (id) => {
        return (
          <div className="flex items-center  justify-center">
            <button
              type="button"
              onClick={() => push(`/solar-details/${id}`)}
              className="text-blue-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            </button>
            <div />
          </div>
        );
      },
    },
  ];

  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageNumber: 1,
    pageSize: 500,
    year: DEFAULT_SEASON_YEAR_NUMBER,
    repName: "",
    agreement_signed_date: "",
    onboarded_date: "",
    managementGroup: "",
    region: "",
  });

  const fetchData = useCallback(() => {
    setLoading(true);
    service
      .getSolarLead()
      .then((resp) => {
        setData(resp.data.data);
        setTotalItems(resp.data.data.length);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Fragment>
      <div className="flex flex-col mb-4">
        <h1 className="page-title">
          Solar Lead Management
        </h1>
        <p className="page-subtitle">View all</p>
      </div>
      <Table
        data={data}
        // handleExport={handleExport}
        pagination={pagination}
        setData={setData}
        exportButton={false}
        // exporting={exporting}
        setPagination={setPagination}
        loadingData={loading}
        // filters={
        //   <Filters pagination={pagination} setPagination={setPagination} />
        // }
        // columnFilters={
        //   <ColumnFilters
        //     pagination={pagination}
        //     setPagination={setPagination}
        //   />
        // }
        totalItems={totalItems}
        columns={columns}
      />
    </Fragment>
  );
};
